module.exports = __webpack_public_path__ + "static/media/bg-2.c5d526e9.png";